module.exports = __webpack_public_path__ + "static/media/to-label.29e43fdd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/suttonparkbus/to-label.svg
// module id = 895
// module chunks = 0